import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {

  constructor(
    public _flowBuilder: FlowBuilderService,
  ) {}




  onDragStart(e:any, outerIndex: string | number, innerIndex: any) {
    if (e.type === 'dragstart') {
      const subNode = this._flowBuilder.sidebar_data[outerIndex]?.submenu;
      this._flowBuilder.selectedItem = (subNode.find((element: any) => element.name === e.target?.id));

    }
  }


}
